export class ArrayUtils {
    public static sampleBalanced<T>(array: T[], maxCount: number): T[] {
        const n = array.length;

        if (n <= maxCount) {
            return array.slice(); // clone pour éviter effets de bord
        }

        const result: T[] = [];
        const step = (n - 1) / (maxCount - 1); // -1 pour inclure l'élément final

        let prevIndex = -1;

        for (let i = 0; i < maxCount; i++) {
            const index = Math.round(i * step);

            // Évite les doublons dus à Math.round en forçant l'incrément
            const adjustedIndex = Math.max(index, prevIndex + 1);

            // Si on dépasse, on s'arrête avant
            if (adjustedIndex >= n) {
                break;
            }

            result.push(array[adjustedIndex]);
            prevIndex = adjustedIndex;
        }

        // Complète si nécessaire (rarement), en prenant les derniers éléments
        while (result.length < maxCount) {
            result.push(array[n - (maxCount - result.length)]);
        }

        return result;
    }
}